import { Icon, Row, Text } from '~/commonComponents';
import { EnforcePostAJobFunnelImprovements } from '~/constants/ff.posthog';
import { useFeatureFlag } from '~/hooks/useFeatureFlag';
import { Colors } from '~/themes/colors';

export const GeneralErrorMessage = () => {
  const isEnforcePostAJobFunnelImprovement = useFeatureFlag(EnforcePostAJobFunnelImprovements);

  return (
    <Row
      gap={6}
      alignItems="center"
      {...(isEnforcePostAJobFunnelImprovement ? { width: 800 } : { marginBottom: 16 })}
    >
      <Icon name="alert-circle" />
      <Text color={Colors.error_500}>
        Oops! It looks like a few required fields were left empty.
      </Text>
    </Row>
  );
};
